<div class="pager-wrapper">


  <div class="select-wrapper">

    <mat-form-field class="full-width">
      <input matInput type="text" placeholder="CPF"
        [formControl]="salesForm.controls.member_cpf" autocomplete="off">
    </mat-form-field>

    <mat-form-field class="full-width">
      <mat-select [formControl]="salesForm.controls.member_id" placeholder="Selecione um membro">
        <mat-option *ngFor="let member of members" [value]="member.id">
          {{ member.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="full-width">
      <mat-select [formControl]="salesForm.controls.product_id" placeholder="Selecione um produto">
        <mat-option *ngFor="let product of products" [value]="product.id">
          {{ product.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>


    <button class="select-button" [disabled]="salesForm.invalid" mat-button (click)="callSalesProcessV1()">
      Enviar
    </button>

  </div>

  <div class="result-wrapper" *ngIf="messageError">
    <span style="color:red;">{{messageError}}</span>
  </div>

  <div *ngIf="dataPack">

    <div class="result-wrapper">

      <span>MEMBRO</span>

      <div class="unit-display">
        <div class="unit-label">Id</div>
        <div class="unit-value">{{dataPack.member.id}}</div>
      </div>

      <div class="unit-display">
        <div class="unit-label">Nome</div>
        <div class="unit-value">{{dataPack.member.name}}</div>
      </div>

      <div class="unit-display">
        <div class="unit-label">E-mail</div>
        <div class="unit-value">{{dataPack.member.email}}</div>
      </div>

      <div class="unit-display">
        <div class="unit-label">Telefone</div>
        <div class="unit-value">{{dataPack.member.cellPhone}}</div>
      </div>

      <div class="unit-display">
        <div class="unit-label">CPF</div>
        <div class="unit-value">{{dataPack.member.cpf}}</div>
      </div>

      <div class="unit-display">
        <div class="unit-label">Situação</div>
        <div class="unit-value" *ngIf="dataPack.member.situation == 0">Quite</div>
        <div class="unit-value" *ngIf="dataPack.member.situation == 1">Não-Quite</div>
        <div class="unit-value" *ngIf="dataPack.member.situation == 2">Isento</div>
      </div>

      <div class="unit-display">
        <div class="unit-label">Credit</div>
        <div class="unit-value">{{dataPack.member.credit}}</div>
      </div>

    </div>

    <div class="result-wrapper">

      <span>CATEGORIA</span>

      <div class="unit-display">
        <div class="unit-label">Id</div>
        <div class="unit-value">{{dataPack.subCategory.id}}</div>
      </div>

      <div class="unit-display">
        <div class="unit-label">Nome</div>
        <div class="unit-value">{{dataPack.subCategory.name}}</div>
      </div>

      <div class="unit-display">
        <div class="unit-label">É Associado</div>
        <div class="unit-value">{{dataPack.subCategory.partner}}</div>
      </div>

      <div class="unit-display">
        <div class="unit-label">Paga Anuidade</div>
        <div class="unit-value">{{dataPack.subCategory.annuity}}</div>
      </div>

      <div class="unit-display">
        <div class="unit-label">Esconde no balcão</div>
        <div class="unit-value">{{dataPack.subCategory.hidden}}</div>
      </div>

      <!--
      <div class="unit-display">
        <div class="unit-label">Documentos</div>
        <div class="unit-value" *ngIf="dataPack.subCategory.documents === ''">Não tem</div>
        <div class="unit-value" *ngIf="dataPack.subCategory.documents !== ''">
          {{dataPack.subCategory.documents}}
        </div>
      </div>
      -->

      <div class="unit-display">
        <div class="unit-label">Documentos</div>
        <div class="unit-value" *ngIf="!dataPack.subCategory.docList">Não tem</div>
        <div class="unit-value" *ngIf="dataPack.subCategory.docList">
          <div *ngFor="let item of dataPack.subCategory.docList">
            {{item.doc}}
          </div>
        </div>
      </div>

    </div>

    <div class="result-wrapper">

      <span>ANUIDADES</span>

      <div class="unit-display">
        <div class="unit-label">Débito</div>
        <div class="unit-value">{{dataPack.balance.debit}}</div>
      </div>

      <div class="unit-display">
        <div class="unit-label">Anuidades em atrazo</div>
        <div class="unit-value">{{dataPack.balance.count}}</div>
      </div>

    </div>

    <div class="result-wrapper">

      <span>PRODUTO</span>

      <div class="unit-display">
        <div class="unit-label">Id</div>
        <div class="unit-value">{{dataPack.product.id}}</div>
      </div>

      <div class="unit-display">
        <div class="unit-label">Nome</div>
        <div class="unit-value">{{dataPack.product.name}}</div>
      </div>

      <div class="unit-display">
        <div class="unit-label">Produto que dá desconto</div>
        <div class="unit-value" *ngIf="dataPack.product.discount_product_id === ''">Não tem</div>
        <div class="unit-value" *ngIf="dataPack.product.discount_product_id !== ''">
          {{dataPack.product.discount_product_id}}
        </div>
      </div>

      <div class="unit-display" *ngIf="dataPack.product.discount_product_id !== ''">
        <div class="unit-label">Porcentagem de desconto</div>
        <div class="unit-value">{{dataPack.product.discount_percent}}</div>
      </div>

      <div class="unit-display">
        <div class="unit-label">Tipo</div>
        <div class="unit-value" *ngIf="dataPack.product.part_of === -1">None</div>
        <div class="unit-value" *ngIf="dataPack.product.part_of === 0">Congresso</div>
        <div class="unit-value" *ngIf="dataPack.product.part_of === 1">Curso</div>
        <div class="unit-value" *ngIf="dataPack.product.part_of === 2">Prova</div>
      </div>

      <div class="unit-display">
        <div class="unit-label">Pré requisitos</div>
        <div class="unit-value" *ngIf="dataPack.product.requirements.length === 0 ">Não tem</div>
        <div class="unit-value" *ngIf="dataPack.product.requirements.length !== 0">
          <div *ngFor="let requirement of dataPack.product.requirements">
            {{requirement.product_name}}
          </div>
        </div>
      </div>

    </div>

    <div class="result-wrapper">

      <span>LOTE DE PREÇO</span>

      <div class="unit-display">
        <div class="unit-label">Id</div>
        <div class="unit-value">{{dataPack.lot.id}}</div>
      </div>

      <div class="unit-display">
        <div class="unit-label">Nome</div>
        <div class="unit-value">{{dataPack.lot.name}}</div>
      </div>

      <div class="unit-display">
        <div class="unit-label">Válido até</div>
        <div class="unit-value">{{dataPack.lot.until_date._seconds*1000 | date: "dd/MM/yyyy"}}</div>
      </div>

    </div>

    <div class="result-wrapper">

      <span>PREÇO</span>

      <div class="unit-display">
        <div class="unit-label">Id</div>
        <div class="unit-value">{{dataPack.prices.id}}</div>
      </div>

      <div class="unit-display">
        <div class="unit-label">Nome</div>
        <div class="unit-value">{{dataPack.prices.name}}</div>
      </div>

      <div class="unit-display">
        <div class="unit-label">Categorias</div>
        <div class="unit-value">{{dataPack.prices.subCategory.name}}</div>
      </div>

      <div class="unit-display">
        <div class="unit-label">Valor</div>
        <div class="unit-value">{{dataPack.prices.value}}</div>
      </div>

      <div class="unit-display">
        <div class="unit-label">Valor Inadimplente</div>
        <div class="unit-value">{{dataPack.prices.value_defaulting}}</div>
      </div>

      <!--
      <div class="unit-display">
        <div class="unit-label">Requer Documentação</div>
        <div class="unit-value">{{dataPack.prices.requires_doc}}</div>
      </div>
      <div class="unit-display" *ngIf="dataPack.prices.requires_doc">
        <div class="unit-label">Documentos</div>
        <div class="unit-value">{{dataPack.prices.list_doc}}</div>
      </div>
      -->

      <div class="unit-display" *ngIf="!dataPack.prices.docList">
        <div class="unit-label">Documentos</div>
        <div class="unit-value">Não tem</div>
      </div>

      <div class="unit-display" *ngIf="dataPack.prices.docList">
        <div class="unit-label">Documentos</div>
          <div *ngFor="let item of dataPack.prices.docList">
            {{item.doc}}
          </div>
      </div>
    </div>

    <div class="result-wrapper">

      <span>EVENTOS</span>

      <div>
        <div *ngFor="let event of dataPack.events">

          <div class="unit-display">
            <div class="unit-label">Id</div>
            <div class="unit-value">{{event.id}}</div>
          </div>
          <div class="unit-display">
            <div class="unit-label">Nome</div>
            <div *ngIf="!dataPack" class="unit-value">-Nome do evento</div>
            <div *ngIf="dataPack" class="unit-value">-{{event.name}}</div>
          </div>
          <div class="unit-display">
            <div class="unit-label">Vagas por tópico</div>
            <div class="unit-value">{{event.ticket_by_topic}}</div>
          </div>
          <div class="unit-display">
            <div class="unit-label">Limite por membro</div>
            <div class="unit-value">{{event.limit_per_member}}</div>
          </div>

          <div class="unit-display" *ngIf="!event.ticket_by_topic">
            <div class="unit-label">Vagas</div>
            <div class="unit-value">{{event.slot_quantity}}</div>
          </div>

          <div class="unit-display" *ngIf="!event.ticket_by_topic">
            <div class="unit-label">Vagas Usadas</div>
            <div class="unit-value">{{event.slot_used}}</div>
          </div>

          <div class="unit-display" *ngIf="!event.ticket_by_topic">
            <div class="unit-label">Espera</div>
            <div class="unit-value">{{event.slot_wait}}</div>
          </div>

          <div class="unit-display" *ngIf="!event.ticket_by_topic">
            <div class="unit-label">Espera Usada</div>
            <div class="unit-value">{{event.slot_wait_used}}</div>
          </div>

          <div *ngFor="let topic of event.topics">

            <br />
            <hr />

            <div class="unit-display">
              <div class="unit-label">Id</div>
              <div class="unit-value">{{topic.id}}</div>
            </div>

            <div class="unit-display">
              <div class="unit-label">Nome</div>
              <div class="unit-value">{{topic.name}}</div>
            </div>

            <div class="unit-display">
              <div class="unit-label">Vagas</div>
              <div class="unit-value">{{topic.slot_quantity}}</div>
            </div>

            <div class="unit-display">
              <div class="unit-label">Vagas Usadas</div>
              <div class="unit-value">{{topic.slot_used}}</div>
            </div>

            <div class="unit-display">
              <div class="unit-label">Espera</div>
              <div class="unit-value">{{topic.slot_wait}}</div>
            </div>

            <div class="unit-display">
              <div class="unit-label">Espera Usada</div>
              <div class="unit-value">{{topic.slot_wait_used}}</div>
            </div>


          </div>

          <br />
          <hr />

        </div>

      </div>

    </div>

    <div class="result-wrapper">

      <span>VAGAS</span>

      <div class="unit-display">
        <div class="unit-label">Tem vaga normal</div>
        <div class="unit-value">{{dataPack.vacancies.canBuyQtd}}</div>
      </div>

      <div class="unit-display">
        <div class="unit-label">Tem lista de espera</div>
        <div class="unit-value">{{dataPack.vacancies.canBuyWait}}</div>
      </div>

    </div>

    <div class="result-wrapper">

      <span>LIMITE POR MEMBRO</span>

      <div class="unit-display">
        <div class="unit-label">Pode comprar?</div>
        <div class="unit-value">{{dataPack.limitForMember.canBuy}}</div>
      </div>

      <div class="unit-display">
        <div class="unit-label">Limite</div>
        <div class="unit-value">{{dataPack.limitForMember.limit}}</div>
      </div>

      <div class="unit-display">
        <div class="unit-label">Compras</div>
        <div class="unit-value">{{dataPack.limitForMember.count}}</div>
      </div>
    </div>

    <div class="result-wrapper">

      <span>VOUCHER</span>

      <div *ngIf="!dataPack.voucher">

        <div class="unit-display">
          <div class="unit-label">Não tem</div>
        </div>
      </div>

      <div *ngIf="dataPack.voucher">

        <div class="unit-display">
          <div class="unit-label">Patrocinador</div>
          <div class="unit-value">{{dataPack.voucher.sponsor_name}}</div>
        </div>

        <div class="unit-display">
          <div class="unit-label">Valor</div>
          <div class="unit-value">{{dataPack.voucher.discount}}</div>
        </div>

        <div class="unit-display">
          <div class="unit-label">Voucher</div>
          <div class="unit-value">{{dataPack.voucher.name}}</div>
        </div>

      </div>

    </div>

    <!--
    <div class="select-wrapper">
      <button class="select-button" mat-button (click)="setDataPackAndGo()">
        Continuar
      </button>
    </div>
    -->

  </div>

</div>